module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftbar-view elffy-dashboard",
    class: {
      'left-aside-toggle': _vm.toggle_aside
    }
  }, [_c('section', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('smallBar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "widget-wrap"
  }, [_c('dateFilter', {
    attrs: {
      "show_month": false,
      "now_year": _vm.now_year,
      "now_month": _vm.now_month,
      "years": _vm.years
    },
    on: {
      "changeYear": _vm.changeYear,
      "changeMonth": _vm.changeMonth
    }
  }), _vm._v(" "), _c('h4', [_c('span', [_vm._v(_vm._s(_vm.now_year) + "年現金流量預估表")])]), _vm._v(" "), _c('div', {
    staticClass: "clear mb-3"
  }), _vm._v(" "), _vm._l((_vm.filtedYearBudget()), function(year_budget) {
    return _c('div', [(_vm.canEditColumn('start_money', year_budget.id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (year_budget.start_money),
        expression: "year_budget.start_money"
      }],
      ref: ('start_money' + year_budget.id),
      refInFor: true,
      staticClass: "form-control mb-2",
      staticStyle: {
        "width": "300px"
      },
      domProps: {
        "value": (year_budget.start_money)
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.target.blur()
        },
        "blur": function($event) {
          _vm.updateBudget(year_budget)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          year_budget.start_money = $event.target.value
        }
      }
    }) : _c('span', {
      staticClass: "pull-left pointer",
      on: {
        "click": function($event) {
          _vm.editColumn('start_money', year_budget.id)
        }
      }
    }, [_vm._v("年初現金：" + _vm._s(year_budget.start_money.toLocaleString()) + " "), _c('i', {
      staticClass: "fa fa-pencil-alt"
    })]), _vm._v(" "), _c('table', {
      staticClass: "table table-bordered"
    }, [_c('tr', [_c('th', {
      staticClass: "text-center"
    }), _vm._v(" "), _vm._l((_vm.months), function(month) {
      return _c('th', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(month) + "月")])
    })], 2), _vm._v(" "), _c('tr', {
      staticClass: "table-secondary bold table-success"
    }, [_c('th', {
      staticClass: "text-left"
    }, [_vm._v("月初現金")]), _vm._v(" "), _vm._l((_vm.month_start), function(money) {
      return _c('th', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(money.toLocaleString()))])
    })], 2), _vm._v(" "), _c('tr', {
      staticClass: "table-secondary bold"
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v("現金收入")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
      return _c('td', {
        staticClass: "text-right pointer",
        on: {
          "click": function($event) {
            _vm.showDetail(month, 'received')
          }
        }
      }, [_vm._v(_vm._s(_vm.sumForCategory(month, 'received').toLocaleString()))])
    })], 2), _vm._v(" "), _c('tr', {
      staticClass: "table-gray bold"
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v("現金支出")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
      return _c('td', {
        staticClass: "text-right pointer",
        on: {
          "click": function($event) {
            _vm.showDetail(month, 'paid')
          }
        }
      }, [_vm._v("-" + _vm._s(_vm.sumForCategory(month, 'paid').toLocaleString()))])
    })], 2), _vm._v(" "), _c('tr', {
      staticClass: "table-gray bold"
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v("現金變化")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
      return _c('td', {
        staticClass: "text-right pointer",
        on: {
          "click": function($event) {
            _vm.showDetail(month, 'all')
          }
        }
      }, [_vm._v(_vm._s((_vm.sumForCategory(month, 'received') - _vm.sumForCategory(month, 'paid')).toLocaleString()))])
    })], 2), _vm._v(" "), _c('tr', {
      staticClass: "table-gray bold table-danger"
    }, [_c('th', {
      staticClass: "text-left"
    }, [_vm._v("月末現金")]), _vm._v(" "), _vm._l((_vm.month_end), function(money) {
      return _c('th', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(money.toLocaleString()))])
    })], 2)]), _vm._v(" "), _vm._m(0, true)])
  })], 2)])])])]), _vm._v(" "), (_vm.showMoneysDetailModal) ? _c('div', [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.showMoneysDetailModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-10",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('h4', [_vm._v("\n              \t顯示明細    \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showMoneysDetailModal = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.temp_moneys.length != 0) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.temp_moneys), function(money) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(money.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getMoneyType(money.money_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.finish_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.amount.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getInvoiceStatus(money.invoice_status)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(money.invoice_at))])])
  })], 2) : _c('h5', {
    staticClass: "text-center mt-3 mb-3"
  }, [_vm._v("沒有收支項目")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.showMoneysDetailModal = false
      }
    }
  }, [_vm._v("關閉")])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('small', [_vm._v("*將所有應收付，實收付列入統計")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("名稱")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("實收付時間")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("金額")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("發票狀態")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("發票開立時間")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e90e7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finances/CashFlowEstimate.vue
// module id = 662
// module chunks = 4